import { repairEntitiesOrder } from "./repairEntitiesOrder.js";
import { sortEntities } from "./sortEntities.js";
const addEntityAtIndex = (entityList, sortableByField, index, preprocess) => {
  const sortedEntities = sortEntities(Array.from(entityList), sortableByField);
  entityList.createNewEntity((getNewlyAdded, options) => {
    let newlyAdded = getNewlyAdded();
    const sortableField = newlyAdded.getRelativeSingleField(sortableByField);
    sortableField.updateValue(index);
    newlyAdded = getNewlyAdded();
    sortedEntities.splice(index, 0, newlyAdded);
    repairEntitiesOrder(sortableByField, sortedEntities);
    preprocess?.(getNewlyAdded, options);
  });
};
export {
  addEntityAtIndex
};
//# sourceMappingURL=addEntityAtIndex.js.map
